package org.braunequip.web.components.models

import kotlinx.serialization.Serializable

@Serializable
data class TimeOffRequestDTO(
    var id: Int? = null,
    var employeeFirstName: String = "",
    var employeeMiddleName: String = "",
    var employeeLastName: String = "",
    var employeeEmail: String = "",
    var employeeContactNumber: String = "",
    var requestStartDate: String = "",   //LocalDate
    var requestEndDate: String = "",     //LocalDate
    var requestReturnDate: String = "",  //LocalDate
    var reason: String = "",
    var usePtoQuestion: Boolean = false,
    var description: String = "",
    var createdAt: String? = null
)